/**
 * @module lineheight/lineheightediting
 */

import LineEditing from '../lineediting';

/**
 * The lineheight editing feature. It introduces the {@link LineHeightCommand command} and adds
 * the `lineheight` attribute for block elements in the {@link Model model}.
 *
 * @extends LineEditing
 */
export default class LineHeightEditing extends LineEditing {

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'LineHeightEditing';
	}

	/**
	 * @inheritDoc
	 */
	constructor( editor ) {
		super( editor, 'lineheight', 'normal', 'line-height', [ 'normal', '1', '1.15', '1.5', '2', '2.5', '3' ] );
	}
}
